import React from 'react';

import { Box } from '@atlaskit/primitives/compiled';

import { useFetchSmartLinkData } from '../../../common/controller/use-fetch-smartlink-data/useFetchSmartLinkData';
import { type CardVariant, KnowledgeSmartCard } from '../../../common/ui/knowledge-smart-card';
import type { KnowledgeCardSource } from '../../../common/ui/knowledge-smart-card/types';
import type { SmartLinkElement } from '../../dynamic-layout-parser/types/dynamic-layout-section';

interface SmartLinkComponentProps {
	component: SmartLinkElement;
	variant?: CardVariant;
}

/**
 * Convert SmartLinkElement to KnowledgeCardSource format
 */
function convertToKnowledgeCardSource(url: string, resolvedData?: any): KnowledgeCardSource {
	return {
		id: resolvedData?.['@id'] || url,
		title: resolvedData?.name || url,
		url,
		product: resolvedData?.generator?.name || null,
		type: resolvedData?.['@type'] || 'link',
		iconUrl: resolvedData?.generator?.icon?.url || null,
		lastModified: resolvedData?.dateModified || null,
		spaceName: null,
		spaceUrl: null,
		ari: resolvedData?.ari,
	};
}

export const DynamicLayoutSmartLink = ({
	component,
	variant,
}: SmartLinkComponentProps): React.JSX.Element | null => {
	const url = component.attributes?.url || '';

	const { objectResolverData } = useFetchSmartLinkData({ urls: [url] });
	const resolvedData = objectResolverData?.[0];

	const source = convertToKnowledgeCardSource(url, resolvedData);

	return (
		<Box testId="dynamic-layout-smart-link">
			<KnowledgeSmartCard source={source} variant={variant} />
		</Box>
	);
};
